// extracted by mini-css-extract-plugin
var _1 = "SimulatorDemo_button__2bbd2";
var _2 = "SimulatorDemo_root__f1ba4";
export { _1 as "button", _2 as "root" }
